import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Select,
} from '@mui/material';
import PropTypes from 'prop-types';

const PaxTerminalModal = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paxTerminalOptions, setPaxTerminalOptions] = useState([]);
  const [selectedPaxTerminal, setSelectedPaxTerminal] = useState({});

  useEffect(() => {
    if (props.paxTerminals?.length > 0) {
      setPaxTerminalOptions(
        props.paxTerminals?.map((terminal) => (
          <MenuItem key={terminal?._id} value={terminal}>
            {`${terminal?.paxTerminalSerial} (${terminal?.paxterminalName})`}
          </MenuItem>
        ))
      );
    }
  }, [props.paxTerminals]);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleSelect = (event) => {
    setSelectedPaxTerminal(event?.target?.value);
  };

  const handleSubmit = () => {
    if (selectedPaxTerminal?._id && selectedPaxTerminal?.paxTerminalSerial) {
      setIsModalOpen(false);
      props.onSubmit(selectedPaxTerminal.paxTerminalSerial);
    }
  };

  return (
    <>
      <Button fullWidth={props.fullWidth} id="open-pax-terminal-modal-button" variant="contained" onClick={handleOpen}>
        Pax Terminal
      </Button>
      <Dialog open={isModalOpen} onClose={handleClose}>
        <DialogTitle>Pax Terminal Selection</DialogTitle>
        <DialogContent>
          <DialogContentText>Choose a terminal.</DialogContentText>
          <Select id="select-serial-number" fullWidth value={selectedPaxTerminal} onChange={handleSelect}>
            {paxTerminalOptions}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" onClick={handleSubmit} disabled={!selectedPaxTerminal?._id}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

PaxTerminalModal.propTypes = {
  paxTerminals: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      paxterminalName: PropTypes.string,
      paxTerminalSerial: PropTypes.string,
    })
  ),
  onSubmit: PropTypes.func,
  fullWidth: PropTypes.bool,
};

export default PaxTerminalModal;
